<template>
  <div class="TextInput" :class="rootCls">
    <i v-if="icon" class="material-icons icon">{{ icon }}</i>
    <input ref="text" type="text" v-model="text" v-on:keyup="onEnter_emit" @focus="focusFlag = true" @blur="focusFlag = false" v-bind="$attrs"/>
    <button v-if="haveText" class="textinput-close material-icons" @click="onClick_clear" aria-label="Apagar texto">close</button>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: {
      type: String,
      required: true
    },
    icon: {
      type: false,
      required: false
    }
  },
  data() {
    return {
      focusFlag: false
    }
  },
  computed: {
    haveText() {
      return this.text.length > 0
    },
    text: {
      get () { return this.value },
      set (text) {
        this.$emit('input', text)
      }
    },
    rootCls () {
      return {
        focused: this.focusFlag
      }
    }
  },
  methods: {
    onClick_clear(event) {
      this.text = ''
      this.$refs['text'].focus()
      event.stopPropagation()
    },
    onEnter_emit(event) {
      this.$emit('keyup', event)
    }
  }
}
</script>